<template>
  <v-container fluid>
    <v-sheet class="pa-4">
      <v-tabs>
        <v-tab v-for="item of tabs" :key="item.value">{{ item.name }}</v-tab>
        <v-tab-item key="order">
          <order />
        </v-tab-item>
        <v-tab-item key="sample">
          <sample />
        </v-tab-item>
      </v-tabs>
    </v-sheet>
  </v-container>
</template>

<script>
import order from "./order/index.vue";
import sample from "./sample/index.vue";
export default {
  data() {
    return {
      tabs: [
        {
          value: "order",
          name: "订单列表",
        },
        {
          value: "sample",
          name: "余样回收",
        },
      ],
    };
  },
  components: {
    order,
    sample,
  },
  methods: {},
  updated() {
    console.log(this.tabValue);
  },
};
</script>
